<script>
export default {
  name: 'CurrentWeight',
  components: {},
  props: {
    weight: {
      type: Number,
      required: true,
      default: 0,
    },
    chest: {
      type: Number,
      required: true,
      default: 0,
    },
    hip: {
      type: Number,
      required: true,
      default: 0,
    },
    waist: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>

<template>
  <div class="page">
    <BaseProgressBar class="base-progress-bar" :limit="2" :progress="1" />
    <div class="container">
      <div class="header">
        <div class="title">
          <h1>Let’s get your measurements.</h1>
        </div>
      </div>
      <div class="form">
        <form>
          <div>
            <div class="row">
              <div class="col">
                <BaseInputTextWithLabel
                  id="weight"
                  type="number"
                  min="0"
                  label="Weight"
                  :value="weight > 0 ? weight : null"
                  @input="$emit('set-weight', $event)"
                  classStyle="simple"
                  placeholder="lbs"
                />
              </div>
              <div class="col">
                <BaseInputTextWithLabel
                  id="chest"
                  type="number"
                  min="0"
                  label="Chest"
                  :value="chest > 0 ? chest : null"
                  @input="$emit('set-chest', $event)"
                  classStyle="simple"
                  placeholder="Chest (in)"
                />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <BaseInputTextWithLabel
                  id="hip"
                  type="number"
                  min="0"
                  label="Hip"
                  :value="hip > 0 ? hip : null"
                  @input="$emit('set-hip', $event)"
                  classStyle="simple"
                  placeholder="Hip (in)"
                />
              </div>
              <div class="col">
                <BaseInputTextWithLabel
                  id="waist"
                  type="number"
                  min="0"
                  label="Waist"
                  :value="waist > 0 ? waist : null"
                  @input="$emit('set-waist', $event)"
                  classStyle="simple"
                  placeholder="Waist (in)"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="buttons">
      <div id="next">
        <BaseButton class="large" @click="$emit('next')">
          Next
          <img src="@assets/images/icons/right-arrow.svg" />
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
// stylelint-disable selector-pseudo-element-no-unknown

.page {
  margin: auto;
  position: relative;
  width: 400px;
  @media screen and (max-width: 900px) {
    width: 100%;
  }

  .progress-bar {
    left: 40px;
    position: absolute;
    right: 40px;
    top: 40px;
  }

  .container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 18px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 65vh;
    margin-top: 56px;
    max-height: 70rem;
    overflow: auto;
    padding-bottom: 13rem;
    position: relative;
    width: 100%;
    .header {
      margin-bottom: 10px;
      text-align: start;
      width: 100%;

      .title {
        h1 {
          font-family: $base-font-family;
          font-size: 36px;
          font-style: normal;
          font-weight: 800;
          line-height: 42px;
          margin: 0 auto 0;
          margin-bottom: 20px;
          padding-top: 60px;
          width: 90%;
        }
      }

      .subtitle {
        color: black;
        font-family: $secondary-font-family;
        font-size: 16px;
        margin: 0;
        width: 100%;

        p {
          line-height: 1.38;
          margin: 0;
          margin-top: 3.25%;
          padding: 0 21px 0 27px;
        }
      }
    }

    .form {
      margin: 0;
      text-align: center;
      width: 100%;

      form {
        .row {
          display: flex;
          flex-wrap: unset;
          margin-left: auto;
          margin-right: auto;
          width: 100%;
          &:first-child {
            padding-bottom: 22px;
          }

          .col {
            padding-left: unset;
            padding-right: unset;
            width: 100%;
            #weight {
              margin-left: auto;
              margin-right: auto;
              width: 85%;
            }
            #chest {
              width: 85%;
            }
            #hip {
              margin-left: auto;
              margin-right: auto;
              width: 85%;
            }
            #waist {
              width: 85%;
            }
          }
        }
        ::v-deep label {
          font-family: $proxima-nova;
          font-weight: 600;
        }
        ::v-deep input {
          font-family: $proxima-nova;
          font-weight: normal;
          &::placeholder {
            font-family: $proxima-nova;
            font-weight: normal;
          }
        }
      }
    }
  }
  .buttons {
    background-color: white;
    border-radius: 8px;
    bottom: 0;
    float: right;
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 10;
    #next {
      float: right;
      margin-bottom: 20px;
      margin-left: auto;
      margin-right: 5%;
      width: 40%;
      button:disabled {
        background-color: lighten($color: #4059e1, $amount: 20);
      }
    }
    #back {
      display: flex;
      flex-direction: column;
      float: left;
      margin: 0;
      margin-right: auto;
      width: 28%;
      button {
        border: unset;
      }
      .large-transparent {
        color: #000;
      }
    }
  }
  &.isMobile {
    height: 100%;
    padding-top: 40px;
    width: 100%;
    .base-progress-bar {
      margin-left: 6.4%;
      width: 87.2%;
    }
    .container {
      box-shadow: unset;
      height: unset;
    }
  }
}
</style>
